import { Button, Grid, Typography } from '@mui/material'
import React from 'react'

export default function CancelPayment({onClose, handleCancelPayment}) {
    const handleCancel =()=>{
        onClose() 
    }
   
  return (
 <>

<Grid container spacing={3}>
    <Grid item xs={12} textAlign='center'>
        <Typography variant='h3'>Are you sure to cancel this payment? </Typography>
    </Grid>
    <Grid item xs={12} container gap={1} justifyContent='end'> 
    <Button variant="outlined" color="error" size="small" onClick={handleCancel}> Cancel</Button>
        <Button variant="contained" color="error" size="small" onClick={handleCancelPayment}> Confirm</Button>

    </Grid>

   </Grid>

   
         
 </>
  )
}
